<template>
  <div>
    <div v-if="$i18n.locale === 'pe'">
      <Message message="" icon="coming_soon_cl.svg" :as-card="true" />
    </div>
    <div v-if="$i18n.locale === 'br'">
      <Message message="" icon="coming_soon_br.svg" :as-card="true" />
    </div>
    <div v-if="$i18n.locale === 'cl'">
      <InputParamsForm hide-params-button-id="hide-params-button" @send="onSend" />
      <transition name="bounce">
        <div v-if="isLoading" class="spinner-content">
          <div class="spinner">
            <div class="double-bounce1" />
            <div class="double-bounce2" />
          </div>
        </div>
      </transition>
      <transition name="slide">
        <div :class="[isResponseHidden ? 'is-hidden' : '']">
          <section id="finance-params-table" class="section">
            <div class="box-content">
              <h4>
                Parámetros Financieros
              </h4>
              <div class="columns">
                <div v-for="(col,i) in financeParams" :key="`col${i}`" class="column">
                  <ul class="finance-params-bullets">
                    <li v-for="(object, j) in col" :key="`row${i},${j}`">
                      <b>{{ object.key }}:</b> {{ object.value }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
          <div class="box-content">
            <Table
              id="amortization-schedule-table"
              v-model="amortizationSchedule"
              title="Tabla de amortización"
              :sticky-header="true" />
          </div>
        </div>
      </transition>
      <transition name="slide">
        <div v-if="errorList.length > 0" class="container">
          <article class="message is-danger">
            <div class="message-header">
              <p>Error</p>
            </div>
            <div class="message-body">
              <p>Revisa los siguientes campos:</p>
              <ol>
                <li v-for="item in errorList" :key="item">
                  {{ item }}
                </li>
              </ol>
            </div>
          </article>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import InputParamsForm from '@/ui/components/internal/amortization-schedule/InputParamsForm.vue';
import Table from '@/ui/components/Table.vue';
import { getAmortizationSchedule } from '@/application/services/api-clients/amortization-schedule';
import Message from '@/ui/components/Message.vue';

export default {
  components: { InputParamsForm, Table, Message },
  data() {
    return {
      errorList: [],
      isLoading: false,
      isResponseHidden: true,
      isMenuHidden: false,
      amortizationSchedule: [],
      serviceResponse: {}
    };
  },
  computed: {
    financeParams: {
      get() {
        const obj = { ...this.serviceResponse };
        delete obj.amortizationScheduleRows;
        const keys = Object.keys(obj);
        const numKeys = keys.length;
        const financeParams = [[], [], []];
        const maxRows = Math.ceil(numKeys / financeParams.length);
        let indexOfColumn = 0;
        keys.forEach((key, i) => {
          const mod = i % maxRows;
          if (mod === 0 && i !== 0 && indexOfColumn < (financeParams.length - 1)) {
            indexOfColumn += 1;
          }
          financeParams[indexOfColumn].push({ key, value: obj[key] });
        });
        return financeParams;
      }
    }
  },
  methods: {
    onSend(body) {
      this.errorList = [];
      this.isLoading = true;
      this.isResponseHidden = true;
      getAmortizationSchedule(body)
        .then(result => {
          this.serviceResponse = result;
          this.isResponseHidden = false;
          this.amortizationSchedule = result.amortizationScheduleRows;
          this.isLoading = false;
        })
        .catch(error => {
          this.errorList = error.response.data.message;
          this.isLoading = false;
        });
    }
  }
};
</script>
<style scoped>
@media (max-width: 768px) {
  .panel-title{
    font-size: 21px;
    color: #00CCD1;
  }
}

.spinner-content{
  margin: 40px auto;
}
section {
  padding-top: 10px;
  padding-bottom: 20px;
}
ol {
  margin-left: 30px;
}
.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}
.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}
.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
.finance-params-bullets {
  list-style-type: circle;
  margin-left: 20px;
}
</style>
